const translations = {
    invalidCoaErrorMessage:
        'Invalid Certificate of Authorization Number (COA), This field cannot contain spaces or special characters.',
    maxExceededErrorMessage: 'Too many characters',
    requiredErrorMessage: 'This field is required'
};

export default translations;
